import { inject, Injectable } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { lastValueFrom } from "rxjs";
import { Installation } from "src/app/backend/models/installation";
import { IntegrationLayoutAction } from "src/app/integrations/integration-layout";
import { InstallationsFunctionsService } from "src/app/modules/bootstrap/functions/installations/installations-functions.service";
import { IntegrationService } from "src/app/services/integration.service";
import { ToastService } from "src/app/services/toast.service";
import { sntTranslate } from "src/app/support/translate";

type Input = {
  installation: Installation;
  params: any;
  action: IntegrationLayoutAction;
};

@Injectable()
export class ExecuteActionInstallationFunctionService {
  private readonly toastService = inject(ToastService);
  private readonly integrationService = inject(IntegrationService);
  private readonly installationsFunctionsService = inject(
    InstallationsFunctionsService
  );

  async execute({ installation, action, params }: Input): Promise<void> {
    if (action.skipConnectionExistenceCheck) {
      await this.integrationService.executeIntegrationAction({
        installation,
        action,
        params
      });
      return;
    }

    const result = await lastValueFrom(
      this.installationsFunctionsService.loadConnectionMeOrConnectToInstallation(
        {
          installationId: installation.id
        }
      )
    );

    switch (true) {
      case result.canceled: {
        await this.toastService.info(
          sntTranslate(marker("Connessione al componente aggiuntivo annullata"))
        );
        break;
      }
      case result.failed: {
        await this.toastService.error(
          sntTranslate(
            marker(
              "Impossibile caricare la connessione al componente aggiuntivo"
            )
          )
        );
        break;
      }
      case !!result.connection?.id: {
        await this.integrationService.executeIntegrationAction({
          installation,
          action,
          params
        });
        break;
      }
    }
  }
}
